// Store and expose only workspace paths, including when a producer supplies an absolute app URL.
export function getWorkspacePath(value: string | null | undefined): string | null {
  if (!value) return null;
  try {
    const url = new URL(value, 'https://workspace.invalid');
    if (!['http:', 'https:'].includes(url.protocol)) return null;
    if (!/^\/(user|admin)\//.test(url.pathname)) return null;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
}

export function conversationTarget(conversationId: number, messageId?: number | null) {
  return `/user/inbox/${conversationId}${messageId ? `?messageId=${messageId}#message-${messageId}` : ''}`;
}

export function leadNotificationTarget(leadId: number, notificationId: number) {
  return `/user/leads/${leadId}?notificationId=${notificationId}#notification-${notificationId}`;
}

export function conversationLabel(conversation: {
  channel: string;
  contactName?: string | null;
  phoneNumber?: string | null;
  externalParticipantId?: string | null;
}) {
  const channel =
    (
      {
        whatsapp: 'WhatsApp',
        instagram: 'Instagram',
        facebook: 'Facebook',
        threads: 'Threads',
      } as Record<string, string>
    )[conversation.channel] ?? 'Social';
  const participant = conversation.externalParticipantId;
  const username = participant?.startsWith(`${conversation.channel}:`)
    ? `@${participant.slice(conversation.channel.length + 1)}`
    : null;
  const contact = conversation.contactName?.trim() || conversation.phoneNumber || username;
  return contact ? `${channel} conversation with ${contact}` : `${channel} customer conversation`;
}

export function messagePreview(content: string | null | undefined) {
  const text = content?.replace(/\s+/g, ' ').trim() ?? '';
  return text.length > 140 ? `${text.slice(0, 137)}...` : text;
}
